import { FC, useContext } from 'react';
import { ResultPeriod } from '../ui';
import { CriteriaTime } from '@src/api';
import { useFormContext } from 'react-hook-form';
import { RuleFactoryChildrenProps } from '../types';
import { DisableContext } from '@pages/Selection/components/DisableContext';
import { DisabledRuleItem } from '@components/DisabledRuleItem';

export const MissingResultRule: FC<RuleFactoryChildrenProps> = ({ prefix, children }) => {
  const { getValues, setValue } = useFormContext();
  const disabled = useContext(DisableContext);

  const scaleTypeName = `${prefix}.scaleType`;

  const [scaleType, scaleValue, loincItem] = getValues([scaleTypeName, `${prefix}.scaleValue`, `${prefix}.loincItem`]);

  const handleClickScaleType = (value: CriteriaTime) => {
    setValue(scaleTypeName, value);
  };

  return disabled ? (
    <DisabledRuleItem
      name="Missing result"
      value={`${scaleValue} ${CriteriaTime[scaleType].toLowerCase()}${scaleValue > 1 ? 's' : ''}`}
      valueName="In the last"
      descriptionName={loincItem?.name}
    />
  ) : (
    <ResultPeriod scaleType={scaleType} handleClickScaleType={handleClickScaleType} prefix={prefix} disabled={disabled}>
      {children}
    </ResultPeriod>
  );
};
